var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeviceBlocked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 40.25H15.3333C13.2162 40.25 11.5 38.5338 11.5 36.4167V9.58333C11.5 7.46624 13.2162 5.75 15.3333 5.75H30.6667C32.7838 5.75 34.5 7.46624 34.5 9.58333V19.1667",
    stroke: "#323232",
    strokeWidth: 2.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7918 5.75V9.58333C27.7918 10.1126 27.3628 10.5417 26.8335 10.5417H19.1668C18.6376 10.5417 18.2085 10.1126 18.2085 9.58333V5.75",
    stroke: "#323232",
    strokeWidth: 2.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2653 32.5132 23.5267 35.2595C23.1902 35.5988 23.001 36.0571 23 36.5349V38.446C23 39.4424 23.8077 40.2502 24.8041 40.2502H26.7234C27.2024 40.2508 27.6617 40.0596 27.9988 39.7194L30.7281 36.9823",
    stroke: "#323232",
    strokeWidth: 2.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.265 32.5129C25.5994 29.8379 26.8 27.0475 29.2 25.6915 31.6 24.3356 34.6097 24.7471 36.5575 26.6977 38.5053 28.6482 38.9127 31.6585 37.5534 34.0566 36.194 36.4546 33.4019 37.6513 30.7279 36.982",
    stroke: "#323232",
    strokeWidth: 2.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2002 31.1459C32.2006 31.1712 32.1909 31.1956 32.1732 31.2137 32.1554 31.2317 32.1312 31.2418 32.1059 31.2417 32.0528 31.2414 32.0095 31.1988 32.0085 31.1457 32.008 31.1205 32.0177 31.0961 32.0354 31.0781 32.0531 31.0601 32.0773 31.05 32.1025 31.05 32.1556 31.0505 32.1987 31.0929 32.2002 31.1459",
    stroke: "#323232",
    strokeWidth: 2.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceBlocked);
export default __webpack_public_path__ + "static/media/device-blocked.a3f69601.svg";
export { ForwardRef as ReactComponent };